import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { CreateOrderResponse, Order } from "../../types/types";
import { RootState } from "../../app/store";
import { API_URL } from "../../config";

export const paymentsApi = createApi({
  reducerPath: "payments",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // The response carries the server's own totals (EB-548), which are not necessarily the ones
    // this request posted — see `CreateOrderResponse`.
    processOrder: builder.mutation<CreateOrderResponse, Partial<Order>>({
      query: (order) => ({
        url: "orders",
        method: "POST",
        body: order,
      }),
    }),
    getOrderById: builder.query<Order, string>({
      query: (id) => `orders/${id}`,
    }),
  }),
});

export const { useProcessOrderMutation, useGetOrderByIdQuery } = paymentsApi;

export default paymentsApi;
